import script from "./widgetCustomScpm.vue?vue&type=script&lang=js"
export * from "./widgetCustomScpm.vue?vue&type=script&lang=js"

import "./widgetCustomScpm.vue?vue&type=style&index=0&id=212a9dc4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212a9dc4"],['__file',"src/components/scpm/widgets/widgetCustomScpm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "212a9dc4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('212a9dc4', __exports__)) {
    api.reload('212a9dc4', __exports__)
  }
  
}


export default __exports__